import { advertNewsCardsContainerElement } from "@modules/global/dom.ts"
import { isMobile, isPC } from "@modules/util/device.ts"
import { debounce } from "lodash-es"
import { soladsBeforePaginationHtmlPc, soladsTemplateDataId } from "../solads/templates.ts"

//TODO move to global
export function rerenderSoladsBeforePagination() {
    if (userData.hasAdFree || userData.isAgeVerified) {
        return
    }
    // remove existing solads element
    const soladsElement = document.querySelector(`[data-solads-id="${soladsTemplateDataId}"]`)
    if (soladsElement) {
        soladsElement.remove()
    }

    const html = isPC() ? soladsBeforePaginationHtmlPc : ""
    advertNewsCardsContainerElement()?.insertAdjacentHTML("afterend", html)
}

if (!userData.hasAdFree && !userData.isAgeVerified) {
    window.addEventListener(
        "orientationchange",
        debounce(() => {
            rerenderSoladsBeforePagination()
        }, 200),
    )

    // DONT initiate an event listener on resize to rerender solads or trafficStars on mobile
    // It will trigger on mobile when scrolling and the browser bar shows/hides. Which triggers a lot of rerenders while scrolling
    // alternative fix would be to check for width changes only.
    if (!isMobile()) {
        window.addEventListener(
            "resize",
            debounce(() => {
                rerenderSoladsBeforePagination()
            }, 200),
        )
    }
    rerenderSoladsBeforePagination()
}
